import { useState } from 'react';
import MunicipalityWiseBorrow from '../../../municipality/borough/municipalityWiseBorrow';

const MenicipaltyAdmin = () => {
  const [isBoroughView, setIsBoroughView] = useState(false);

  const municipalityName = localStorage.getItem('municipality_name_v2') || 'Unknown Municipality';
  const municipalityId = parseInt(localStorage.getItem('municipality_id_v2') || '9', 10);

  return (
    <MunicipalityWiseBorrow
      breadCrumb={setIsBoroughView}     
      isBoroughView={isBoroughView}  
      municipalityId={municipalityId}
      municipalityName={municipalityName}
    />
  );
};

export default MenicipaltyAdmin;